'use client';

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useLanguage } from '@/contexts/LanguageContext';


interface PriceData {
  year: number;
  goldPrice: number;
  silverPrice: number;
}

interface HistoricalDataComparisonProps {
  data: PriceData[];
}

const HistoricalDataComparison = ({ data }: HistoricalDataComparisonProps) => {
  const { t } = useLanguage();

  const chartData = data.map((item) => ({
    year: item.year.toString(),
    [t('whyGoldSilver.historical.gold')]: item.goldPrice,
    [t('whyGoldSilver.historical.silver')]: item.silverPrice
  }));

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-8 relative overflow-hidden">
      <div className="relative z-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary mb-3">
          {t('whyGoldSilver.historical.title')}
        </h2>
        <p className="font-body text-base text-muted-foreground mb-8">
          {t('whyGoldSilver.historical.subtitle')}
        </p>

        <div className="h-[400px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis
                dataKey="year"
                stroke="var(--color-muted-foreground)"
                style={{ fontSize: '14px' }} />

              <YAxis
                stroke="var(--color-muted-foreground)"
                style={{ fontSize: '14px' }}
                label={{
                  value: t('whyGoldSilver.historical.pricePerKg'),
                  angle: -90,
                  position: 'insideLeft',
                  style: { fill: 'var(--color-muted-foreground)' }
                }} />

              <Tooltip
                contentStyle={{
                  backgroundColor: 'var(--color-card)',
                  border: '1px solid var(--color-border)',
                  borderRadius: '8px'
                }} />

              <Legend />
              <Bar
                dataKey={t('whyGoldSilver.historical.gold')}
                fill="var(--color-accent)"
                radius={[8, 8, 0, 0]} />

              <Bar
                dataKey={t('whyGoldSilver.historical.silver')}
                fill="var(--color-primary)"
                radius={[8, 8, 0, 0]} />

            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );

};

export default HistoricalDataComparison;